import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5c48f8fd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5c48f8fd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c48f8fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c48f8fd')) {
      api.createRecord('5c48f8fd', component.options)
    } else {
      api.reload('5c48f8fd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5c48f8fd&scoped=true", function () {
      api.rerender('5c48f8fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Problem/component/showImageDialog/index.vue"
export default component.exports